import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../../hoc/Loading/Loading";
import axios from "../../../axios";
import * as actionCreators from "../../../modules/actions/index";
import { connect } from "react-redux";
import * as url from "../../../utils/url";
import {
  whiteLabelStyling,
  isUserRemoved,
  groupContentFields,
  groupPrivacyStatusDesc,
} from "../../../utils/constants";
import { toolkitCategories } from "../../../utils/categories";
import moment from "moment";
import {
  Table,
  Modal,
  ModalBody,
  Button,
  ListGroupItem,
  Progress,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
  Alert,
  ModalHeader,
  Input,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import noResources from "../../../assets/onboarding/toolkit.png";
import loadingItems from "../../../assets/placeholders/kpi_available.svg";
import { isMobile } from "../../../utils/deviceInfo";
import ToolDetails from "../../toolkit/ToolDetails/Details/ToolDetails";
import { CSVLink } from "react-csv";

const toolStaticHeaders = [
  { label: "Tool Name", key: "name" },
  { label: "Linked On", key: "dateLinked" },
  { label: "Tool Category", key: "category" },
  { label: "Website", key: "website" },
];

class MetricsResources extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: "",
      resources: [],
      resourcesCopy: [],
      dropdownOpen: false,
      isSuccess: false,
      removedItem: null,
      isLoaded: false,
      mobileDetailsPopupOpen: false,
      popupParams: {},
      popupPath: "",
    };
  }

  getData(tools) {
    const toolsToExport = tools.map(item => ({
      name: item.name,
      category: item.category,
      dateLinked: moment(item.createDate).format("MMM Do, YYYY"),
      website: item.website,
    }));

    return toolsToExport;
  }

  componentDidMount() {
    let { id } = this.props.match.params;
    if (this.props.renderIntoMetricsPopup) {
      id = this.props.group._id;
    }
    let that = this;
    let payload = {
      groupId: id,
      modelName: "OfficeToolkit",
      noLoader: true,
      // modelType:'Conferences & Events'
    };
    this.props.highlightMenu("R");
    axios.post(url.getSingleGroupItems, payload).then(({ data }) => {
      that.setState({
        resources: [...data.data.items],
        resourcesCopy: [...data.data.items],
        isLoaded: true,
      });
    });
  }

  toggleMobileDetailsPopup = () => {
    if (this.state.mobileDetailsPopupOpen) {
      this.setState({ popupParams: {}, popupPath: "" });
    }
    this.setState({
      mobileDetailsPopupOpen: !this.state.mobileDetailsPopupOpen,
    });
  };

  removeGroup = item => {
    let { resources } = this.state;
    if (this.props.group) {
      let payload = {
        modelId: item._id,
        modelName: "OfficeToolkit",
        // itemType:item.itemType,
        groupId: this.props.group._id,
      };
      let that = this;
      axios.post(url.removeGrpItem, payload).then(({ data }) => {
        let res = resources.filter(({ modelId: ev }) => ev._id != item._id);
        that.setState({
          // isRemoved:true
          resources: res,
          removedItem: item,
          isSuccess: true,
          // selected:null,
          // linkedGrp:result,  modDoc:doc,
          // groupList:[ doc ,...this.state.groupList],
          // displayItems:result
          // groupList:
          // isSuccessMsg: 0,
          // selected: {...selected, ...data.data}
        });
      });
    }
  };

  viewTool = tool => {
    let { category } = tool;
    let tool_cat = toolkitCategories.filter(e => e.name == category)[0];
    let tool_link = `/home/toolkit/${tool_cat.link}/tool/${tool._id}`;
    if (isMobile) {
      this.setState({
        mobileDetailsPopupOpen: true,
        popupParams: {
          id: tool._id,
          category: tool_cat.link,
          popupPath: tool_link,
        },
      });
    } else {
      let { category } = tool;
      let tool_cat = toolkitCategories.filter(e => e.name == category)[0];
      let tool_link = `/home/toolkit/${tool_cat.link}/tool/${tool._id}`;
      this.props.history.push(tool_link);
    }
  };

  onDismiss = () => {
    this.setState({ isSuccess: false, removedItem: null });
  };
  handleSearchQueryChanged = e => {
    const val = e.target.value;
    const { resourcesCopy } = this.state;
    if (val) {
      const newEvents = resourcesCopy.filter(x =>
        x.name.toLowerCase().includes(val.toLowerCase())
      );
      this.setState({ resources: [...newEvents] });
    } else {
      this.setState({ resources: [...resourcesCopy] });
    }
  };
  renderResources = tasks => {
    const { orgAdmin } = this.props.user.profile;
    let { resources, isSuccess, removedItem } = this.state;
    return (
      <span>
        {isSuccess ? (
          <Alert color="success" isOpen={isSuccess} toggle={this.onDismiss}>
            <strong>{removedItem.name}</strong> was removed.
          </Alert>
        ) : null}

        <div
          className={
            this.props.renderIntoMetricsPopup
              ? ""
              : "singleTaskToolkitTableContainerBox"
          }
        >
          <Table
            responsive
            borderless={this.props.renderIntoMetricsPopup ? true : false}
            hover
            className="taskToolkitTable"
          >
            <thead>
              <tr>
                <th>Name</th>
                <th>Category</th>
                {/* <th>Created By</th> */}
                <th>Date Linked</th>
                <th> </th>
              </tr>
            </thead>
            <tbody>
              {/* resources.map(({modelId:item},idx) => */}
              {resources.map((item, idx) => {
                return (
                  <React.Fragment key={idx + item._id}>
                    <tr className="linkedToolTable" key={item._id}>
                      <td>
                        {item.name}{" "}
                        <span
                          className="linkedToolView"
                          onClick={() => this.viewTool(item)}
                        >
                          (view)
                        </span>
                      </td>

                      <td>{item.category}</td>

                      <td className="grp_single_page_event_date_css">
                        {moment(item.createDate).format("MMM Do, YYYY")}
                      </td>

                      <td className="grp_single_page_remove_css">
                        {!this.props.renderIntoMetricsPopup && (
                          <span
                            onClick={() => this.removeGroup(item)}
                            className="chart-item-menu flaticon-trash"
                          />
                        )}
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </Table>
        </div>
      </span>
    );
  };

  render() {
    let { resources, isLoaded, mobileDetailsPopupOpen } = this.state;
    const { renderIntoMetricsPopup, resourcesPopupOpen, toggle } = this.props;

    return (
      <Modal isOpen={resourcesPopupOpen}>
        <ModalHeader toggle={toggle} className="metrics-mobile-header">
          Group Resources
          {resources.length ? (
            <span
              className={`single_group_menu_events_export_btn ${
                isMobile ? "" : "ml-5"
              }`}
            >
              <CSVLink
                data={this.getData(resources)}
                headers={toolStaticHeaders}
                filename={`Group Resources - ${moment().format(
                  "MM/DD/YYYY"
                )}.csv`}
                target="_blank"
              >
                {resources && resources.length > 0
                  ? "Export Group Resources to CSV"
                  : "No resources"}
              </CSVLink>
            </span>
          ) : (
            ""
          )}
        </ModalHeader>
        <ModalBody>
          <span
            className={
              renderIntoMetricsPopup
                ? ""
                : "grp_single_page_stories_container resources_component_container"
            }
          >
            {mobileDetailsPopupOpen && (
              <Modal
                isOpen={mobileDetailsPopupOpen}
                toggle={this.toggleMobileDetailsPopup}
              >
                <ModalHeader toggle={this.toggleMobileDetailsPopup}>
                  View Resource
                </ModalHeader>
                <ModalBody>
                  <ToolDetails
                    match={{ params: this.state.popupParams }}
                    isPopup={true}
                    history={{
                      location: { pathname: this.state.popupPath, search: "" },
                      ...this.props.history,
                    }}
                  />
                </ModalBody>
              </Modal>
            )}
            <div className="search-export-button-div">
              <InputGroup style={{ height: "40px" }}>
                <Input
                  className="toolkit-field tool-search-box"
                  placeholder="Search ..."
                  onChange={this.handleSearchQueryChanged}
                />
                <InputGroupAddon addonType="append">
                  <i
                    style={{ color: "#818389", padding: "7px" }}
                    className="flaticon-search"
                  ></i>
                </InputGroupAddon>
              </InputGroup>
            </div>

            {isLoaded != true ? (
              <div
                className={
                  renderIntoMetricsPopup
                    ? "grp_single_page_metrics_popup_container"
                    : "grp_single_page_details_analytics_container"
                }
              >
                <span className="grp_single_page_no_analytics">
                  <img src={loadingItems} className="grpNoLinkedCharts" />{" "}
                  Loading...
                </span>
              </div>
            ) : isLoaded ? (
              resources && resources.length > 0 ? (
                <div
                  className={
                    renderIntoMetricsPopup
                      ? ""
                      : "grp_single_page_resources_component_container"
                  }
                >
                  {this.renderResources()}
                </div>
              ) : (
                <div
                  className={
                    renderIntoMetricsPopup
                      ? "grp_single_page_metrics_popup_container"
                      : "grp_single_page_details_analytics_container"
                  }
                >
                  <span
                    className={
                      renderIntoMetricsPopup
                        ? "grp_single_page_metrics cursor-pointer"
                        : "grp_single_page_no_analytics cursor-pointer"
                    }
                  >
                    <img src={noResources} className="grpNoLinkedCharts" /> No
                    items have been linked to Resources.
                    <div
                      className="grp_page_resources_subtitle"
                      onClick={() =>
                        this.props.history.push(`/home/toolkit/all`)
                      }
                    >
                      Click here to link Resources.
                    </div>
                  </span>
                </div>
              )
            ) : null}
          </span>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: dashboard => dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(MetricsResources, axios)));
